const logKeys = {
  vehicle: 'vehicleId',
  driver: 'driverId',
  obu: 'OBU'
}

export default logKeys
